import { render, staticRenderFns } from "./BackToHome.vue?vue&type=template&id=3b20a47a&"
import script from "./BackToHome.vue?vue&type=script&lang=js&"
export * from "./BackToHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports